export default __webpack_public_path__ + "static/media/me3-V2 [English].3a30cbb0.vtt";